import { connect, } from 'react-redux';
import reduxMount from 'utils/reduxMounter';
import { bindActionCreators, } from 'redux';
import { queryString, } from 'utils/window';
import { warn, info, } from 'application/console';
import { facebook, } from 'config/externalScripts';
import { isCampaignEnabled, } from 'config/campaignConfig';
import { facebookBotReducer, } from './facebookBotReducer';
import { facebookBotActions, } from './facebookBotActions';
import { facebookBotConfig, } from './facebookBotMounterConfig';
import { external as externalScriptLoader, } from 'utils/script';
import { MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig';
import FacebookBotComponent from './components/facebookBotComponent';
import { injectFacebookBotInsideArticle, } from './facebookBotNodeInjector';


const { FACEBOOK_BOT_MOUNT_POINT, } = MOUNT_POINTS;
const COMPONENT_NAME = "FacebookBot";
const STATE_KEY = "facebookBot";
const { forceFacebookBot, } = queryString;
const facebookScriptLoader = externalScriptLoader.load({
  name: facebook.name, });


function mapStateToProps(state){
  const { displayMessage, appId, pageId, } = state[STATE_KEY];
  return {
    className: 'post-body-wrap__facebook-bot',
    displayMessage,
    pageId,
    appId,
  };
}

function mapStateToDispatch(dispatch){
  return bindActionCreators(facebookBotActions, dispatch);
}

const FacebookBotContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, mapStateToDispatch)(FacebookBotComponent),
  reducer: facebookBotReducer,
};

function injectFacebookBotMountPointAndMount(){
  injectFacebookBotInsideArticle();
  reduxMount({
    [FACEBOOK_BOT_MOUNT_POINT]: FacebookBotContainer,
  });
}

function loadFbScriptInjectAndMount(){
  facebookScriptLoader(injectFacebookBotMountPointAndMount);
}

function runFacebookBotCampaign({ isCampaignEnabled: isFacebookBotCampaignEnabled, }){
  if (isFacebookBotCampaignEnabled) {
    loadFbScriptInjectAndMount();
  }
}

export default function mountFacebookBot(){
  if (forceFacebookBot) {
    info('[QS] forcing facebook bot');
    return loadFbScriptInjectAndMount();
  }
  return isCampaignEnabled(facebookBotConfig)
    .then(runFacebookBotCampaign)
    .catch(warn);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotMounter.js